<template>
  <div class="flex flex-col w-full mx-auto min-h-screen items-center justify-between">
    <header
      class="flex w-full justify-between py-2 items-center bg-[#009FE3] fixed z-10 pr-4 md:pl-0 pl-12"
    >
      <div class="flex gap-2 items-center">
        <span class="flex items-center -ml-7">
          <button @click="toggleCollapsed" class="block md:hidden mr-4">
            <MenuOutlined class="text-white" />
          </button>

          <router-link to="/menu">
            <div class="flex items-center lg:ml-12">
              <div class="md:block hidden mr-3">
                <img :src="PRINT.logosolo" alt="Logo de la Municipalidad" class="w-8" />
              </div>
              <h1 class="lg:hidden font-bold text-gray-200 text-sm ml-1 md:ml-12">
                {{ SYSTEM.abbreviation }}
              </h1>
              <h1 class="hidden text-base font-bold text-gray-200 lg:block lg:text-base">
                {{ SYSTEM.description }}
              </h1>
            </div>
          </router-link>
        </span>
      </div>
      <div id="content-user">
        <a-dropdown class="border-none text-white font-bold hover:text-white">
          <template #overlay>
            <a-menu>
              <router-link to="/mi-cuenta">
                <a-menu-item key="1"> <UserOutlined /> Mi cuenta </a-menu-item>
              </router-link>
              <a-menu-item key="2" @click="logout"><LogoutOutlined /> Cerrar sesión </a-menu-item>
            </a-menu>
          </template>
          <a-button >
            <UserOutlined class="text-md" />
            {{ nombreUsuario }}
            <DownOutlined class="text-lg" />
          </a-button>
        </a-dropdown>
      </div>
    </header>
    <main class="mb-auto w-full md:flex md:content-between">
      <aside class="hidden md:block w-auto">
        <MenuLateral />
      </aside>
      <aside class="w-full mt-12 bg-gray-100 min-h-screen">
        <slot></slot>
      </aside>
    </main>
  </div>
  <a-back-top />
</template>

<script>
import MenuLateral from "@/components/MenuLateral.vue";
import { UserOutlined, DownOutlined, LogoutOutlined, MenuOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";
import { SYSTEM, PRINT } from "@/utils/shared";

export default {
  components: {
    MenuLateral,
    UserOutlined,
    DownOutlined,
    LogoutOutlined,
    MenuOutlined
  },
  data() {
    const store = useStore();

    const nombreUsuario = store.state?.usuarios?.usuario?.SESSION_NOMBRE;
    const usuario = store.state?.usuarios?.usuario?.SESSION_USUARIO;

    async function logout() {
      store
        .dispatch("usuarios/logout", usuario)
        .then((res) => console.log(res))
        .catch((err) => console.log(err)); // for debug
    }

    function toggleCollapsed() {
      store.dispatch("navegacion/toggleCollapsed");
    }
    return {
      logout,
      toggleCollapsed,
      nombreUsuario,
      SYSTEM,
      PRINT
    };
  }
};
</script>

<style>
#content-user .ant-dropdown-trigger {
  background: none;
}
#content-user .ant-dropdown-trigger:hover {
  background: #f8f7f7;
  color: black;
}
.ant-modal-close-x {
  color: #ec4f4f !important;
  box-shadow: 5cm;
  font-weight: bold;
}
.ant-modal-close-x:hover {
  color: #ff0000 !important;
}
</style>
